var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"l-container"},[_c('div',{staticClass:"l-container__inner"},[_c('h1',[_vm._v("hogehoge")]),_vm._v(" "),_vm._t("body")],2),_vm._v(" "),_c('common-breadcrumb')],1)}
var staticRenderFns = []

export { render, staticRenderFns }